import {IRootState, RootState} from "../root-state.store";
import {IMaintenanceService, MaintenanceService} from "../../services";
import {ActivityStatus} from "../../common/enums";
import {EquipmentDto, IEquipment} from "../../models/equipment/equipment.model";
import { IMaintenance, MaintenanceDto } from "../../models/maintenance/maintenance.model";
import { Pagination } from "../../models/generic";
import { ITemplateMaintenance, TemplateMaintenanceDto } from "../../models/maintenance/template-maintenance.model";


export interface IMaintenanceSearchParams {
  $limit:number
  $skip:number
  block?:number
  apartment?:number[]
  method?:string[]
  state?:string[]
  type?:string[]
  creator?:number[]
  manager?:number[]
  contractor?:number[]
  char1?:number
  char2?:number[]
  q?:string
  equipment?:number
}

export interface IMaintenanceState extends IRootState<IMaintenanceService> {
  isLoading:boolean
  maintenance?:IMaintenance;
  maintenanceTemplate?:ITemplateMaintenance;
  maintenanceIntervalTypes?:any[]
  maintenanceTemplates?:any[]
  equipment?: IEquipment;
  currentEquipment?: any;
  equipments?: any[];
  attributeToEdit?: {value: string};
  currentAttribute?: {value: string};
  blockEquipmentParameter?: any;
  blockEquipmentData?: {
    list: any[],
    total: number,
    totalPage: number,
    currentPage: number,
    loading: boolean,
    limit:number
  };
  blockVehicleFleetParameter?: any;
  blockVehicleFleet?: {
    list: any[],
    total: number,
    totalPage: number,
    currentPage: number,
    loading: boolean,
    limit:number
  };
  maintenances:any[],
  maintenancesSearchParams:IMaintenanceSearchParams

}

export class MaintenanceState extends RootState implements IMaintenanceState {
  isLoading:boolean
  maintenance?:IMaintenance;
  maintenanceTemplate?:ITemplateMaintenance;
  maintenanceIntervalTypes?:any[]
  maintenanceTemplates?:any[]
  equipment?: IEquipment;
  currentEquipment?: any;
  equipments?: any[];
  attributeToEdit?: {value: string};
  currentAttribute?: {value: string};
  blockEquipmentParameter?: any;
  blockEquipmentData?: {
    list: any[],
    total: number,
    totalPage: number,
    currentPage: number,
    loading: boolean,
    limit:number
  };
  blockVehicleFleetParameter?: any;
  blockVehicleFleet?: {
    list: any[],
    total: number,
    totalPage: number,
    currentPage: number,
    loading: boolean,
    limit:number
  };
  maintenances:any[];
  maintenancesSearchParams:IMaintenanceSearchParams

  constructor () {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new MaintenanceService
    this.isLoading = false
    this.maintenance = new MaintenanceDto({})
    this.maintenanceTemplate = new TemplateMaintenanceDto({})
    this.maintenanceIntervalTypes = []
    this.maintenanceTemplates = []
    this.maintenances = []
    this.equipment = new EquipmentDto({number_equipment: 1})
    this.currentEquipment = null
    this.equipments = []
    this.attributeToEdit = {value: null}
    this.currentAttribute = {value: null}
    this.blockEquipmentParameter = {
      q: '',
      block: null,
      apartment: [],
      char1: null,
      char2: null,
      disable: false,
      attributeFilters:'[]'
    }
    this.blockEquipmentData = {
      list: [],
      total: 0,
      totalPage: 0,
      currentPage: 1,
      loading: false,
      limit:10
    }
    this.blockVehicleFleetParameter = {
      q: '',
      block: null,
      apartment: [],
      char1: 238,
      char2: null,
      disable: false,
      attributeFilters:'[]'
    }
    this.blockVehicleFleet = {
      list: [],
      total: 0,
      totalPage: 0,
      currentPage: 1,
      loading: false,
      limit:10
    }
    this.maintenancesSearchParams = {$limit:10,$skip:0,state:['triggered','waiting']}
  }
}



// WEBPACK FOOTER //
// ./src/store/maintenance/maintenance-state.store.ts